export interface OpenableDetails {
  open: boolean;
}

export interface ElementContainer {
  contains(target: Node | null): boolean;
}

export function closeDetailsMenus(...menus: Array<OpenableDetails | null | undefined>) {
  for (const menu of menus) {
    if (menu) menu.open = false;
  }
}

export function isOutsideElement(target: EventTarget | null, container: ElementContainer | null | undefined) {
  return Boolean(target && container && !container.contains(target as Node));
}

export function isDirectBackdropPointer(target: EventTarget | null, currentTarget: EventTarget | null) {
  return target === currentTarget;
}
